import docIcon from '@public/doc-icon.svg';
import pdfIcon from '@public/pdf-icon.svg';
import xmlIcon from '@public/xml-icon.svg';
import imageIcon from '@public/image-icon.svg';
import folderIcon from '@public/folder-icon.svg';

export const allFilesData = [
  {
    id: '90020',
    file: {
      name: 'pink_yowza.doc',
      avatar: docIcon,
    },
    size: '7.6MB',
    type: 'doc',
    modified: '2023-08-06T07:36:49.630Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    ],
  },
  {
    id: '86128',
    file: {
      name: 'grunt_around.xml',
      avatar: xmlIcon,
    },
    size: '8.8MB',
    type: 'xml',
    modified: '2024-03-30T20:16:17.243Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
    ],
  },
  {
    id: '76411',
    file: {
      name: 'gee.xml',
      avatar: xmlIcon,
    },
    size: '7.4MB',
    type: 'xml',
    modified: '2022-11-08T02:05:58.667Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
    ],
  },
  {
    id: '97993',
    file: {
      name: 'adventurously_neatly',
      avatar: folderIcon,
    },
    size: '6.1MB',
    type: 'folder',
    modified: '2022-09-08T21:11:20.818Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    ],
  },
  {
    id: '76697',
    file: {
      name: 'utterly_modernity_acidly.xml',
      avatar: xmlIcon,
    },
    size: '6.7GB',
    type: 'xml',
    modified: '2023-03-07T22:27:09.014Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    ],
  },
  {
    id: '38724',
    file: {
      name: 'electric.xml',
      avatar: xmlIcon,
    },
    size: '4.3MB',
    type: 'xml',
    modified: '2023-11-17T01:13:45.153Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    ],
  },
  {
    id: '90218',
    file: {
      name: 'from_powerful.webp',
      avatar: imageIcon,
    },
    size: '2.3GB',
    type: 'image',
    modified: '2023-11-24T03:30:18.409Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    ],
  },
  {
    id: '74618',
    file: {
      name: 'helplessly',
      avatar: folderIcon,
    },
    size: '1.4GB',
    type: 'folder',
    modified: '2023-01-13T14:18:23.860Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    ],
  },
  {
    id: '60917',
    file: {
      name: 'white_which.gif',
      avatar: imageIcon,
    },
    size: '6.7GB',
    type: 'image',
    modified: '2022-11-01T00:18:22.613Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
    ],
  },
  {
    id: '35976',
    file: {
      name: 'associate_hence_claim.gif',
      avatar: imageIcon,
    },
    size: '9GB',
    type: 'image',
    modified: '2023-03-23T04:32:48.697Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
    ],
  },
  {
    id: '43393',
    file: {
      name: 'who_enterprise.pdf',
      avatar: pdfIcon,
    },
    size: '4.4GB',
    type: 'pdf',
    modified: '2022-09-30T17:37:19.899Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    ],
  },
  {
    id: '83362',
    file: {
      name: 'gallivant.xml',
      avatar: xmlIcon,
    },
    size: '4.9GB',
    type: 'xml',
    modified: '2024-05-28T19:56:28.077Z',
    shared: [
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    ],
  },
];
